import type { KnowledgeBase } from 'src/services/knowledgeBaseService';

// Knowledge bases assigned to the project first, each group keeping its original order.
export const assignedFirst = (items: KnowledgeBase[], projectId: number): KnowledgeBase[] => {
  const isAssigned = (item: KnowledgeBase) =>
    Boolean(item.projects?.some((project) => project.id === projectId));

  return [...items.filter(isAssigned), ...items.filter((item) => !isAssigned(item))];
};
